import React from 'react';

export default function StatCard({ title, value, emoji, gradient, textColor }) {
  return (
    <div className={`rounded-2xl p-5 flex items-center gap-4 shadow-sm border ${gradient}`}>
      <div className="text-3xl">{emoji}</div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{title}</p>
        <p className={`text-2xl font-extrabold mt-0.5 ${textColor}`}>{value}</p>
      </div>
    </div>
  );
}